<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-col :span="24">
                <el-form :inline="true" :model="form" class="demo-form-inline">
                  <el-form-item label="输入搜索：">
                    <el-input
                      v-model="form.title"
                      placeholder="消息公告标题"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      v-model="form.admin_name"
                      placeholder="创建人"
                      @keyup.native.enter="search"
                    ></el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-select
                      v-model="form.is_benchmarking"
                      placeholder="是否标杆商家"
                    >
                      <el-option
                        v-for="item in is_benchmarking"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="form.supply_level"
                      placeholder="商家等级"
                    >
                      <el-option
                        v-for="item in supply_level"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="创建时间：">
                    <el-date-picker
                      v-model="form.create_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="发布时间：">
                    <el-date-picker
                      v-model="form.publish_time"
                      type="datetimerange"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="search">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="reset">重置</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row v-if="!loading">
      <el-col style="border: 1px solid #ddd">
        <el-row
          :span="24"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-col :span="8">数据列表：</el-col>
          <el-col :span="16" style="text-align: right">
            <el-button
              type="danger"
              style=""
              size="mini"
              @click="showEditNotice"
              >新建消息公告</el-button
            >
            <el-button type="success" style="" size="mini" @click="output">
              导出</el-button
            >
          </el-col>
        </el-row>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column type="index" label="序号" align="center">
              ></el-table-column
            >
            <el-table-column
              prop="title"
              label="消息公告标题"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="admin_name"
              label="创建人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="publish_time"
              label="发布时间"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_notice_is_benchmarking"
              label="是否标杆商家"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="supply_level"
              label="商家等级"
              align="center"
            ></el-table-column>
            <el-table-column prop="read_num" label="已读量" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="showRead(scope.row)">
                  {{ scope.row.read_num }}<br />
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.publish_status == 1"
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >详情</el-button
                >
                <el-button
                  v-if="scope.row.publish_status == 0"
                  type="text"
                  size="small"
                  @click="handleClick(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  v-if="scope.row.publish_status == 0"
                  style="color: red"
                  type="text"
                  size="small"
                  @click="handleDelete(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <el-dialog title="已读商家列表" :visible.sync="readVisible">
            <el-table :data="readSupplyDetail.list">
              <el-table-column
                property="supply_name"
                label="商家"
                align="center"
              ></el-table-column>
            </el-table>
          </el-dialog>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper ,sizes"
            :total="resData.count"
            :page-size="form.pagesize"
            :page-sizes="[50, 100, 200, 500]"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <edit-notice
      ref="edit_notice_ref"
      :parent_data="notice_data"
      :supply_notice_id="supply_notice_id"
    ></edit-notice>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

import EditNotice from "./components/EditNotice.vue";
// 无数据打标
export default {
  components: {
    EditNotice,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {});
  },
  data() {
    return {
      resData: {},
      form: {
        create_time: this.defaultDate(),
        pagesize: 50,
        page: 1,
      },
      loading: false,
      url: "/erp/Supply/supplyNoticeList",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      msg: "",
      is_benchmarking: [
        { key: "", name: "全部" },
        { key: "1", name: "是" },
        { key: "0", name: "否" },
      ],
      supply_level: [
        { key: "", name: "全部" },
        { key: "S", name: "S" },
        { key: "A", name: "A" },
        { key: "B", name: "B" },
        { key: "C", name: "C" },
      ],
      supply_notice_id: "0",
      // 无数据打标相关
      notice_data: {
        show_dialog: false,
      },
      readVisible: false,
      readSupplyDetail: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },

  // created() {
  //     this.fetchData()
  // },
  methods: {
    showRead(row) {
      this.$http
        .post("/erp/supply/showNoticeReadSupply", {
          supply_notice_id: row.supply_notice_id,
        })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.readSupplyDetail = res.data.data;
            this.readVisible = true;
          }
        });
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 14);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    showEditNotice() {
      this.supply_notice_id = "0";
      this.$nextTick((_) => {
        this.notice_data.show_dialog = true;
        this.$refs.edit_notice_ref.initForm();
      });
    },
    handleSizeChange($val) {
      this.form.pagesize = $val;
      this.fetchData(true);
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleClick(row) {
      this.supply_notice_id = row.supply_notice_id;
      this.$nextTick((_) => {
        this.notice_data.show_dialog = true;
        this.$refs.edit_notice_ref.initForm();
      });
    },
    handleDelete(row) {
      this.$confirm("确认删除?", "", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.fullscreenLoading = true;
          this.$http
            .post("/erp/Supply/deleteNotice", {
              supply_notice_id: row.supply_notice_id,
            })
            .then((result) => {
              this.fullscreenLoading = false;
              if (result.data.code != 200) {
                return this.$message.e(result.data.msg);
              }
              this.$message.success(result.data.msg);
              this.fetchData(true);
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    output() {
      this.form.is_excel = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        this.form.is_excel_detail = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },

    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData(true);
    },
    search() {
      this.form.page = 1;
      this.form.is_excel = 0;
      this.fetchData(true);
    },

    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    reset() {
      this.form = {
        create_time: this.defaultDate(),
        pagesize: 50,
        page: 1,
      };
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1rpx solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.tab-div {
  border: 1px solid #ddd;
  margin: 20px 0;
  padding: 10px 0 10px 20px;
}

.tag-css {
  margin-left: 10px;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.el-dropdown-menu__item {
  background-color: #f56c6c;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/SupplyNoticeList.vue